import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
  defaultDataIdFromObject,
} from 'apollo-cache-inmemory'

import introspectionQueryResultData from 'generated/fragmentTypes.json'

export function createCache() {
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
  })

  const cache = new InMemoryCache({
    dataIdFromObject: (object: any) => {
      return defaultDataIdFromObject(object)
    },
    fragmentMatcher,
  })

  // Define default state.  Initially, we will use this only for the Later
  // Later Suitability flow, but this can be extended to any place where we
  // want to store client-side state
  cache.writeData({
    data: {
      storedQuestions: [],
      recommendation: null,
      coreSuitabilityQuestions: [],
      showCoreSuitabilityQuestions: false,
      page: 1,
      showNextButton: false,
      existingCoreCustomer: false,
    },
  })

  return cache
}
